/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

const InvoiceDetailToolbar = ({
  clickToSearch,
  datesearch,
  handleChangeselect,
  selectvalue,
  selectvalues,
  handleChangeselected,
  fromdate,
  todate,
  handleSearchText
}) => {
  const [firstdate, setFirstDate] = useState(null);
  const [seconddate, setSecondDate] = useState(null);
  const [searchtext, setSearchtext] = useState('');

  const handleSearchInvNo = (inv) => {
    setSearchtext(inv);
    handleSearchText(inv);
  };

  useEffect(() => {
    if (fromdate) setFirstDate(new Date(fromdate)); // Convert to Date object
    if (todate) setSecondDate(new Date(todate));   // Convert to Date object
  }, [fromdate, todate]);

  return (
    // <Box {...props}>
    <Box>
      <Box sx={{ mt: 0 }}>
        <Card>
          <CardContent>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={3} style={{ display: 'flex' }}>
                  <h2>Invoice Details</h2>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={3} style={{ display: 'flex' }}>
                  <TextField
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon fontSize="small" color="action">
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    sx={{ width: '50ch' }}
                    placeholder="Search "
                    onChange={(e) => handleSearchInvNo(e.target.value)}
                    onKeyPress={(e) => clickToSearch(e, '1')}
                  />
                  <Button
                    variant="contained"
                    onClick={() => clickToSearch(searchtext, '2')}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={2} style={{ display: 'grid' }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Status</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Status"
                      value={selectvalues}
                      onChange={handleChangeselected}
                    >
                      <MenuItem value={0}>All</MenuItem>
                      <MenuItem value={1}>Unconfirmed</MenuItem>
                      <MenuItem value={2}>Confirmed/Unapproved</MenuItem>
                      <MenuItem value={3}>Approved</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2} style={{ display: 'grid' }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Delivery Type</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Delivery Type"
                      value={selectvalue}
                      onChange={handleChangeselect}
                    >
                      <MenuItem value={5}>All</MenuItem>
                      <MenuItem value={1}>Standard</MenuItem>
                      <MenuItem value={2}>Stock Transfer</MenuItem>
                      <MenuItem value={3}>Deluxe</MenuItem>
                      <MenuItem value={4}>Extra Charges</MenuItem>
                      <MenuItem value={6}>Sales Return</MenuItem>
                      <MenuItem value={7}>Service Call</MenuItem>
                      <MenuItem value={8}>Labour Hire</MenuItem>
                      <MenuItem value={9}>Truck Booking(4T/6T/10T/van)</MenuItem>
                      <MenuItem value={10}>Other Booking</MenuItem>
                      <MenuItem value={11}>Cancellation</MenuItem>
                      <MenuItem value={12}>Tip Run</MenuItem>
                      <MenuItem value={13}>Line Haul Fee</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Settlement From Date"
                      value={firstdate || null}
                      format="yyyy-MM-dd"
                      onChange={(newValue) => {
                        setFirstDate(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={2}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Settlement To Date"
                      value={seconddate}
                      onChange={(newValue) => {
                        setSecondDate(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                      format="yyyy-MM-dd"
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={1}>
                  <Button
                    color="primary"
                    onClick={() => {
                      datesearch(firstdate, seconddate);
                    }}
                  >
                    <SvgIcon fontSize="large" color="action">
                      <SearchIcon />
                    </SvgIcon>
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box >
  );
};

export default InvoiceDetailToolbar;
